import { styled } from '@mui/material/styles';
import { TableBody as MuiTableBody } from '@mui/material';

export const TableBody = styled(MuiTableBody)(({ theme }) => ({
  '& tr': {
    '& td': {
      border: 'none !important',
      minWidth: '150px'
    },
    '& .delete-btn': {
      color: theme.color.danger.main,
      border: `1px solid transparent`,

      '&:hover': {
        border: `1px solid ${theme.color.danger.main}`
      },
      '&:active': {
        border: `1px solid ${theme.color.danger.main}`
      }
    },
    '& .download-btn': {
      color: theme.color.primary.main,
      border: `1px solid transparent`,
      '&:hover': {
        border: `1px solid ${theme.color.primary.main}`
      },
      '&:active': {
        border: `1px solid ${theme.color.primary.main}`
      }
    }
  }
}));
